import { render } from "./Login.vue?vue&type=template&id=1bff5850&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=1bff5850&lang=less&scoped=true"
import "./Login.vue?vue&type=style&index=1&id=1bff5850&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bff5850"]])

export default __exports__